import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../App';

function Privacy() {
  const { t, language } = useLanguage();
  const sections = t.privacy.sections;

  const localeMap = { tr: 'tr-TR', en: 'en-US', de: 'de-DE', fr: 'fr-FR', es: 'es-ES', it: 'it-IT' };
  const formattedDate = new Date(2026, 7, 28).toLocaleDateString(localeMap[language] || 'en-US', { day: 'numeric', month: 'long', year: 'numeric' });

  return (
    <div className="page-content">
      <Helmet>
        <title>Chefyz - {t.privacy.title}</title>
        <meta name="description" content={t.privacy.intro} />
        <meta property="og:title" content={`Chefyz - ${t.privacy.title}`} />
        <meta property="og:description" content={t.privacy.intro} />
      </Helmet>
      <div className="page-header">
        <div className="container">
          <h1>{t.privacy.title}</h1>
          <p>{t.privacy.lastUpdated}: {formattedDate}</p>
        </div>
      </div>

      <div className="page-body">
        <div className="container">
          <div className="legal-content">
            <div className="legal-intro">
              {t.privacy.intro}
            </div>

            {Object.entries(sections).map(([key, section]) => (
              <div key={key} className="legal-section">
                <h2>{section.title}</h2>
                <p>{section.content}</p>
              </div>
            ))}

            <div className="legal-section">
              <h2>📧 {sections.contact?.title || 'Contact'}</h2>
              <p>
                Email: <a href="mailto:privacy@chefyz.ai">privacy@chefyz.ai</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
